export default __webpack_public_path__ + "static/media/HOTEL_BG.61732f77.jpg";